// Elumen Quiz Logic
const quiz = {
  currentScreen: 'start',
  answers: { skinTone: null, hairColor: null, goal: null, condition: null },
  
  init() {
    this.bindEvents();
    this.showScreen('start');
  },

  bindEvents() {
    // Start button
    document.getElementById('startBtn').addEventListener('click', () => this.showScreen('q1'));
    
    // Back buttons
    document.querySelectorAll('[data-back]').forEach(btn => {
      btn.addEventListener('click', () => this.showScreen(btn.dataset.back));
    });
    
    // Next buttons
    document.querySelectorAll('[data-next]').forEach(btn => {
      btn.addEventListener('click', () => {
        const screen = btn.dataset.next;
        if (screen === 'loading') {
          this.showScreen('loading');
          this.runLoading();
        } else {
          this.showScreen(screen);
        }
      });
    });

    // Option selection (Q1, Q2, Q3)
    document.querySelectorAll('[data-question]').forEach(card => {
      card.addEventListener('click', () => {
        const q = card.dataset.question;
        const val = card.dataset.value;
        this.answers[q] = val;
        // Deselect siblings
        card.closest('.options-grid, .pill-options').querySelectorAll('[data-question]').forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        // Enable next button
        const footer = card.closest('.screen').querySelector('.btn-primary');
        if (footer) footer.removeAttribute('disabled');
      });
    });

    // Restart buttons
    document.querySelectorAll('[data-restart]').forEach(btn => {
      btn.addEventListener('click', () => {
        this.answers = { skinTone: null, hairColor: null, goal: null, condition: null };
        document.querySelectorAll('.selected').forEach(el => el.classList.remove('selected'));
        this.showScreen('start');
      });
    });
  },

  showScreen(id) {
    this.currentScreen = id;
    document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
    const screen = document.getElementById('screen-' + id);
    if (screen) {
      screen.classList.add('active');
      screen.scrollTop = 0;
      window.scrollTo(0, 0);
    }
    // Update progress
    const progressMap = { q1: 25, q2: 50, q3q4: 75 };
    const bar = document.getElementById('progressFill');
    if (bar && progressMap[id]) bar.style.width = progressMap[id] + '%';
  },

  calculateResult() {
    const { skinTone, hairColor, goal, condition } = this.answers;
    
    // Vibrant Creator: goal is statement
    if (goal === 'statement') return 'vibrant';
    
    // Deep Mirror: dark hair + deep color goal, or dark hair + damaged
    if ((hairColor === 'dunkelbraun' || hairColor === 'hellbraun') && goal === 'deep') return 'deep';
    if (hairColor === 'dunkelbraun' && condition === 'strapaziert') return 'deep';
    
    // Cool Ice: cool skin tone
    if (skinTone === 'silber') return 'cool';
    if (skinTone === 'beides' && (hairColor === 'lichtblond' || hairColor === 'mittelblond')) return 'cool';
    
    // Golden Glow: warm skin tone
    if (skinTone === 'gold') return 'golden';
    if (skinTone === 'beides' && goal === 'natural') return 'golden';
    
    // Default fallback
    if (hairColor === 'dunkelbraun') return 'deep';
    if (goal === 'natural') return 'golden';
    return 'cool';
  },

  runLoading() {
    const steps = document.querySelectorAll('#screen-loading .loading-step');
    const pct = document.getElementById('loadPct');
    let progress = 0;
    
    const interval = setInterval(() => {
      progress += 2;
      if (pct) pct.textContent = Math.min(progress, 100) + '%';
      
      if (progress >= 30 && steps[0]) { steps[0].classList.add('done'); steps[0].classList.remove('active'); }
      if (progress >= 30 && steps[1]) steps[1].classList.add('active');
      if (progress >= 65 && steps[1]) { steps[1].classList.add('done'); steps[1].classList.remove('active'); }
      if (progress >= 65 && steps[2]) steps[2].classList.add('active');
      if (progress >= 95 && steps[2]) { steps[2].classList.add('done'); steps[2].classList.remove('active'); }
      
      if (progress >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          const result = this.calculateResult();
          this.showScreen('result-' + result);
        }, 500);
      }
    }, 60);
  }
};

document.addEventListener('DOMContentLoaded', () => quiz.init());
